import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Activity, Mail, Calendar, CreditCard, FileSignature, CheckCircle2, AlertCircle } from 'lucide-react';
export function AdminIntegrationsHealthPage() {
  return <div className="min-h-screen bg-background text-textMain flex flex-col" data-id="element-1123">
      <header className="h-16 border-b border-border flex items-center justify-between px-6 bg-surface shrink-0" data-id="element-1124">
        <div className="flex items-center gap-4" data-id="element-1125">
          <span className="text-xl font-bold text-red-500" data-id="element-1126">Booker Admin</span>
          <div className="w-px h-6 bg-border" data-id="element-1127"></div>
          <nav className="flex items-center gap-4 text-sm font-medium" data-id="element-1128">
            <Link to="/admin" className="text-textMuted hover:text-textMain" data-id="element-1129">
              Dashboard
            </Link>
            <Link to="/admin/integrations-health" className="text-textMain" data-id="element-1130">
              Integrations Health
            </Link>
          </nav>
        </div>
      </header>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="flex-1 p-8 max-w-7xl mx-auto w-full" data-id="element-1131">
        <div className="mb-8" data-id="element-1132">
          <h1 className="text-2xl font-bold mb-1" data-id="element-1133">Integrations Health</h1>
          <p className="text-sm text-textMuted" data-id="element-1134">
            Monitor API status for email, calendar, payment, and signing
            providers.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-1135">
          <div className="bg-surface border border-border rounded-xl p-6" data-id="element-1136">
            <div className="flex items-center justify-between mb-6" data-id="element-1137">
              <div className="flex items-center gap-3" data-id="element-1138">
                <div className="w-10 h-10 rounded-lg bg-blue-500/10 flex items-center justify-center text-blue-500" data-id="element-1139">
                  <Mail className="w-5 h-5" data-id="element-1140" />
                </div>
                <div data-id="element-1141">
                  <h3 className="font-bold" data-id="element-1142">Email Providers</h3>
                  <p className="text-xs text-textMuted" data-id="element-1143">
                    Google Workspace & Microsoft 365
                  </p>
                </div>
              </div>
              <span className="px-2 py-1 bg-green-500/10 text-green-500 text-[10px] font-bold uppercase tracking-wider rounded flex items-center gap-1" data-id="element-1144">
                <CheckCircle2 className="w-3 h-3" data-id="element-1145" /> Operational
              </span>
            </div>
            <div className="space-y-3 text-sm" data-id="element-1146">
              <div className="flex justify-between border-b border-border pb-2" data-id="element-1147">
                <span className="text-textMuted" data-id="element-1148">Connected Accounts</span>
                <span className="font-medium" data-id="element-1149">1,420</span>
              </div>
              <div className="flex justify-between border-b border-border pb-2" data-id="element-1150">
                <span className="text-textMuted" data-id="element-1151">Sync Delay</span>
                <span className="font-medium text-green-500" data-id="element-1152">&lt; 2s</span>
              </div>
              <div className="flex justify-between" data-id="element-1153">
                <span className="text-textMuted" data-id="element-1154">API Rate Limit Status</span>
                <span className="font-medium" data-id="element-1155">42% (Healthy)</span>
              </div>
            </div>
          </div>

          <div className="bg-surface border border-border rounded-xl p-6" data-id="element-1156">
            <div className="flex items-center justify-between mb-6" data-id="element-1157">
              <div className="flex items-center gap-3" data-id="element-1158">
                <div className="w-10 h-10 rounded-lg bg-purple-500/10 flex items-center justify-center text-purple-500" data-id="element-1159">
                  <Calendar className="w-5 h-5" data-id="element-1160" />
                </div>
                <div data-id="element-1161">
                  <h3 className="font-bold" data-id="element-1162">Calendar Sync</h3>
                  <p className="text-xs text-textMuted" data-id="element-1163">
                    Google Calendar & Outlook
                  </p>
                </div>
              </div>
              <span className="px-2 py-1 bg-amber-500/10 text-amber-500 text-[10px] font-bold uppercase tracking-wider rounded flex items-center gap-1" data-id="element-1164">
                <AlertCircle className="w-3 h-3" data-id="element-1165" /> Degraded
              </span>
            </div>
            <div className="space-y-3 text-sm" data-id="element-1166">
              <div className="flex justify-between border-b border-border pb-2" data-id="element-1167">
                <span className="text-textMuted" data-id="element-1168">Connected Accounts</span>
                <span className="font-medium" data-id="element-1169">2,105</span>
              </div>
              <div className="flex justify-between border-b border-border pb-2" data-id="element-1170">
                <span className="text-textMuted" data-id="element-1171">Sync Delay</span>
                <span className="font-medium text-amber-500" data-id="element-1172">
                  ~45s (Elevated)
                </span>
              </div>
              <div className="flex justify-between" data-id="element-1173">
                <span className="text-textMuted" data-id="element-1174">Failed Webhooks (1h)</span>
                <span className="font-medium text-red-500" data-id="element-1175">12</span>
              </div>
            </div>
          </div>

          <div className="bg-surface border border-border rounded-xl p-6" data-id="element-1176">
            <div className="flex items-center justify-between mb-6" data-id="element-1177">
              <div className="flex items-center gap-3" data-id="element-1178">
                <div className="w-10 h-10 rounded-lg bg-green-500/10 flex items-center justify-center text-green-500" data-id="element-1179">
                  <CreditCard className="w-5 h-5" data-id="element-1180" />
                </div>
                <div data-id="element-1181">
                  <h3 className="font-bold" data-id="element-1182">Payment Rails</h3>
                  <p className="text-xs text-textMuted" data-id="element-1183">Stripe Connect</p>
                </div>
              </div>
              <span className="px-2 py-1 bg-green-500/10 text-green-500 text-[10px] font-bold uppercase tracking-wider rounded flex items-center gap-1" data-id="element-1184">
                <CheckCircle2 className="w-3 h-3" data-id="element-1185" /> Operational
              </span>
            </div>
            <div className="space-y-3 text-sm" data-id="element-1186">
              <div className="flex justify-between border-b border-border pb-2" data-id="element-1187">
                <span className="text-textMuted" data-id="element-1188">Active Connect Accounts</span>
                <span className="font-medium" data-id="element-1189">840</span>
              </div>
              <div className="flex justify-between border-b border-border pb-2" data-id="element-1190">
                <span className="text-textMuted" data-id="element-1191">Processing Volume (24h)</span>
                <span className="font-medium" data-id="element-1192">$142,500</span>
              </div>
              <div className="flex justify-between" data-id="element-1193">
                <span className="text-textMuted" data-id="element-1194">Webhook Latency</span>
                <span className="font-medium text-green-500" data-id="element-1195">120ms</span>
              </div>
            </div>
          </div>

          <div className="bg-surface border border-border rounded-xl p-6" data-id="element-1196">
            <div className="flex items-center justify-between mb-6" data-id="element-1197">
              <div className="flex items-center gap-3" data-id="element-1198">
                <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center text-primary" data-id="element-1199">
                  <FileSignature className="w-5 h-5" data-id="element-1200" />
                </div>
                <div data-id="element-1201">
                  <h3 className="font-bold" data-id="element-1202">E-Sign Provider</h3>
                  <p className="text-xs text-textMuted" data-id="element-1203">
                    Internal / DocuSign API
                  </p>
                </div>
              </div>
              <span className="px-2 py-1 bg-green-500/10 text-green-500 text-[10px] font-bold uppercase tracking-wider rounded flex items-center gap-1" data-id="element-1204">
                <CheckCircle2 className="w-3 h-3" data-id="element-1205" /> Operational
              </span>
            </div>
            <div className="space-y-3 text-sm" data-id="element-1206">
              <div className="flex justify-between border-b border-border pb-2" data-id="element-1207">
                <span className="text-textMuted" data-id="element-1208">Docs Out for Signature</span>
                <span className="font-medium" data-id="element-1209">312</span>
              </div>
              <div className="flex justify-between border-b border-border pb-2" data-id="element-1210">
                <span className="text-textMuted" data-id="element-1211">Completion Rate</span>
                <span className="font-medium" data-id="element-1212">88%</span>
              </div>
              <div className="flex justify-between" data-id="element-1213">
                <span className="text-textMuted" data-id="element-1214">API Status</span>
                <span className="font-medium text-green-500" data-id="element-1215">Healthy</span>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>;
}